import { useAppState } from "./useAppState";

/**
 * @returns the key for an LI bene or an empty string
 */
export const useBeneKey = (): string => {
  const { beneficiary } = useAppState();
  const beneKey = beneficiary?.meta_data.beneficiary_key;
  return beneKey ?? "";
};
